/* ============
 * Main File
 * ============
 *
 * Will initialize the application
 */
import Vue from 'vue';
import * as App from './app';

import httpInterceptor from './app/services/http-interceptor';

import './app/global-style.css';
import './tailwind.css';
import i18n from './i18n';
import CountryFlag from 'vue-country-flag';
import TextareaAutosize from 'vue-textarea-autosize';
Vue.use(TextareaAutosize);


Vue.component('country-flag', CountryFlag);
Vue.prototype.$http = httpInterceptor;
require('./bootstrap');

//new Vue(App).$mount('#app');
new Vue({
    i18n,
    render: h => h(App)
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js